export default __webpack_public_path__ + "static/media/instagram.58b237e0.svg";